import * as React from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../../../../theme';
import { useToggleable } from '../../../../../../hooks';
import { BaseButton } from '../../../../../../BaseComponents';
import ModalConfirm from '../../../../../../ModalConfirm';
import { useRefuseExchange } from '../../model/useRefuseExchange';
const RefuseExchangeButton = ({ className, onSuccess }) => {
    const { t } = useTranslation('Exchange');
    const { RefuseExchangeButton: theme } = useTheme('Features').Exchange;
    const { isOpen, open, close } = useToggleable(false);
    const { onRefuseExchange, isLoading } = useRefuseExchange();
    const onRefuseExchangeHandler = useCallback(() => {
        onRefuseExchange({ onSuccess });
        close();
    }, [onSuccess, onRefuseExchange, close]);
    return (React.createElement(React.Fragment, null,
        React.createElement(BaseButton, { variant: "secondary", className: cn(theme.root, className), isLoading: isLoading, onClick: open }, t('RefuseExchangeButton.Label')),
        React.createElement(ModalConfirm, { isOpen: isOpen, title: t('RefuseExchangeButton.ModalLabel'), onClose: close, onCancel: close, onConfirm: onRefuseExchangeHandler }, t('RefuseExchangeButton.ModalText'))));
};
export default RefuseExchangeButton;
